// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Products_SetPrimaryImageInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/products/setPrimaryImage
 *
 * Promotes a single product gallery image to primary. The controller is
 * responsible for atomically clearing `is_primary` on the other images
 * of the same product (transaction-wrapped) and for verifying the image
 * exists before promotion. This contract only guards the shape of the input.
 */
import { registerContract } from './validate'

export interface Products_SetPrimaryImageInput {
so_product_image_id: number
}

registerContract('Products_SetPrimaryImageInput', {
  so_product_image_id: { type: 'number',  required: true },
})
